// API Configuration for production
const API_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.PROD ? 'https://api.swirlapp.ai/v1' : 'http://localhost:4028/v1');

export default API_URL;
